// extracted by mini-css-extract-plugin
export var actions = "EmbargoedEnrollmentModal-module__actions___fjO-D";
export var body = "EmbargoedEnrollmentModal-module__body___0Yhke";
export var browseButton = "EmbargoedEnrollmentModal-module__browseButton___GvTGT";
export var closeButton = "EmbargoedEnrollmentModal-module__closeButton___Q6k7s";
export var content = "EmbargoedEnrollmentModal-module__content___qF0fy";
export var description = "EmbargoedEnrollmentModal-module__description___CIFd6";
export var documentTypeDropdown = "EmbargoedEnrollmentModal-module__documentTypeDropdown___aWNtC";
export var error = "EmbargoedEnrollmentModal-module__error___wkjXk";
export var evidenceOption = "EmbargoedEnrollmentModal-module__evidenceOption___43V9S";
export var evidenceOptions = "EmbargoedEnrollmentModal-module__evidenceOptions___dg3xA";
export var fileDetail = "EmbargoedEnrollmentModal-module__fileDetail___ZXUyK";
export var fileInput = "EmbargoedEnrollmentModal-module__fileInput___ZagCy";
export var fileName = "EmbargoedEnrollmentModal-module__fileName___ZVpfH";
export var fileRow = "EmbargoedEnrollmentModal-module__fileRow___DRcE8";
export var header = "EmbargoedEnrollmentModal-module__header___klEOU";
export var hint = "EmbargoedEnrollmentModal-module__hint___t+RLV";
export var input = "EmbargoedEnrollmentModal-module__input___fRz6q";
export var label = "EmbargoedEnrollmentModal-module__label___YsVqv";
export var section = "EmbargoedEnrollmentModal-module__section___x6cWp";
export var sectionTitle = "EmbargoedEnrollmentModal-module__sectionTitle___9epMc";
export var title = "EmbargoedEnrollmentModal-module__title___AP12B";
export var uploadBox = "EmbargoedEnrollmentModal-module__uploadBox___JYJe-";
export var visuallyHidden = "EmbargoedEnrollmentModal-module__visuallyHidden___ITXZK";